import React, { Component, Fragment } from "react";
import styled from "styled-components";
import ReactButton from "common-components/Buttons";
import { media } from "utils/style";
import CommonContainer from "common-components/Container";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { convertStringToElements } from "@vds/html-parsers";
import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import FetchPageContent from "../../../../hoc/FetchPageContent";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions"
import { sendSecurePinToDevice } from "../../FormerCustomer/actions/commonFormerCustomerAPI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import FallbackUI from "../../FallbackUI/FallbackUI";
import { ENDPOINTS } from "utils/endpoints";
import Alert from "common-components/Alert";
import Notification from "../../../../../assets/svgs/Notification.svg";
class CustomerDownloadPasswordPage extends Component {

  state = {
    showAlert: false
  }

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("verify identity", this.props.pageContent.sc_pagetitle);
    }
  }

  handleCopy = (value) => {
    navigator.clipboard.writeText(value)
    this.setState({
      showAlert: true
    })
  }

  checkForCSRFTokenInfo = () => {
    const el = document.querySelector('meta[name="csrfToken"]');
    if (el && el.getAttribute("content")) {
      return el.getAttribute("content");
    }
    return "";
  };

  render() {
    const { pageContent, loading, downloadFileInfo, fileFormat, fileSize } = this.props;

    if (!pageContent) {
      return <FallbackUI />;
    }

    if (loading) {
      return <RectangleLoader />;
    }
    const { ccpaFlow, amUUId, loggedInMdn, amAccountNumber, amVZId, amComVZId } = window.reactGlobals;
    const isUnregistered =
      ccpaFlow &&
      typeof ccpaFlow === "string" &&
      (ccpaFlow.toLowerCase() === "guest" ||
        ccpaFlow.toLowerCase() === "ivr_unregistered" ||
        ccpaFlow.toLowerCase() === "former" ||
        ccpaFlow.toLowerCase() === "wireline_unregistered");

    const actionUrl = isUnregistered
      ? "/privacy/your-data/api/download/file"
      : "/privacy/secure/api/download/file";

    const unregisteredPostParams = isUnregistered && (
      <Fragment>
        <input hidden type="text" name="AM_UUID" readOnly value={amUUId} />
        <input hidden type="text" name="AM_CCPA_FLOW" readOnly value={ccpaFlow} />
        <input hidden type="text" name="VPD_CCPA_FLOW" readOnly value={ccpaFlow} />
        <input hidden type="text" name="AM_MOBILE_NUMBER" readOnly value={loggedInMdn} />
        <input hidden type="text" name="AM_ACCOUNT_NUMBER" readOnly value={amAccountNumber} />
        <input hidden type="text" name="AM_VZID" readOnly value={amVZId} />
        <input hidden type="text" name="AM_COMVZID" readOnly value={amComVZId} />
      </Fragment>
    );

    const fileFormatObject = downloadFileInfo.genericList[0].list[0];
    return (
      <Fragment>
        <Container>
          <H1>{pageContent.section_title}</H1>
          <Div id="section_desc">
            {convertStringToElements(pageContent.section_description)}
          </Div>
          <DivBox>
            <P1>{this.props.passwordKey}</P1>
          </DivBox>
          <Button id="copy_password_link" onClick={() => this.handleCopy(this.props.passwordKey)}>
            {pageContent.genericList[0].list[0].jsonValue}
          </Button>
          <H2>
            {downloadFileInfo.section_title}
          </H2>
          <Div>
            {convertStringToElements(downloadFileInfo.section_description)}
          </Div>
          <Div>
            {fileFormatObject.jsonKey} .{fileFormat.toUpperCase()}{" "}
            {fileFormat.toUpperCase() === "XLSX" ? fileFormatObject.excelValue : fileFormatObject.jsonValue}
          </Div>
          <Div style={{ marginBottom: "34px" }}>
            {downloadFileInfo.genericList[0].list[1].jsonKey} {fileSize}
          </Div>
          <form
            action={ENDPOINTS.AGENT_DOWNLOAD_FILE}
            method="post"
            encType="application/x-www-form-urlencoded"
          >
            <input hidden type="text" name="uniqueTxnId" readOnly value={this.props.uniqueTxnId} />
            <input hidden type="text" name="mtn" readOnly value={this.props.mtn} />
            <input hidden type="text" name="csrfTokenInfo" readOnly value={this.checkForCSRFTokenInfo()} />
            <Button type="submit" background={downloadFileInfo.buttons[0].type}>
              {downloadFileInfo.buttons[0].text}
            </Button>
          </form>
          {this.state.showAlert ?
            <Alert alertType="copycliboard" afterCloseRequest={() => this.setState({ showAlert: false })}>
              <div style={{ display: 'flex' }}>
                <img src={Notification} aria-hidden="true" alt="" />
                <p>
                  <p>{pageContent.genericList[0].list[1].jsonKey}</p>
                  <p>{pageContent.genericList[0].list[1].jsonValue}</p>
                </p>
              </div>
            </Alert> : null}
        </Container>
      </Fragment>
    );
  }
}


CustomerDownloadPasswordPage.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({
  pageContent: { password_form: pageContent, breadCrumbs, download_file: downloadFileInfo, },
  loadingAndErrorState: { loading, error },
  agentSelectedCustomerDownload,
  agentSelectedCustomer: { mtn },
  downloadPasswordKey
}) => ({
  pageContent,
  breadCrumbs,
  downloadFileInfo,
  loading,
  error,
  fileFormat: agentSelectedCustomerDownload.fileFormat,
  fileSize: agentSelectedCustomerDownload.fileSize,
  passwordKey: downloadPasswordKey.key,
  uniqueTxnId: agentSelectedCustomerDownload.uniqueTxnId,
  mtn
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList, sendSecurePinToDevice }
  ),
  FetchPageContent
)(CustomerDownloadPasswordPage);

const Button = styled(ReactButton)`
  margin-top: 8px;
  ${media.mobile`
    margin-right: 0;
  `}
`;
const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 47px 80px ;
  #copy_password_link  {
    text-decoration: underline !important;
    border: transparent !important;
    background-color: transparent !important;
    padding: 0 !important;
    cursor: pointer !important;
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif !important;
    font-size: 12px !important;
    line-height: 16px !important;
    letter-spacing: 0.5px !important;
    font-weight: 400 !important;
    color: #6F7171;
  }
  #copy_password_link:focus, #copy_password_link.focus {
      outline: none !important;
  }
  #section_desc {
    padding: 12px 0px 24px 0px !important;
  }
  ${media.mobile`
    padding: 48px 16px;
  `}
`;
const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  font-weight: 300;
  width: 486px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
    line-height: 36px;
`}
`;
const Div = styled.div`
  width: 490px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    padding-bottom: 15px;
    font-size: 16px;
    line-height: 20px;
  }
  ${media.mobile`
    max-width: 100%;
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
  `}
`;
const P1 = styled.p`
  font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
`;
const H2 = styled.h1`
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  width: 486px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-style: normal;
  padding: 48px 0px 15px 0px;
  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
    line-height: 36px;
    padding: 48px 0px 15px 0px;
`}
`;
const DivBox = styled.div`
  display: flex;
  width: 328px;
  height: 44px;
  padding: 1px 1px 1px 15px;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #6F7171;
`;